import axios from 'axios';

window.axios = axios;


window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Ajouter baseURL globale (si tu veux cibler une API spécifique)
window.axios.defaults.baseURL = '/';

// Ajouter le token CSRF (important pour POST/PUT/DELETE)
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

// Exemple : intercepteur pour gérer les erreurs globales
window.axios.interceptors.response.use(
    response => response,
    error => {
        console.error('Erreur API :', error.response?.data || error.message);
        return Promise.reject(error);
    }
);